<template>
  <form role="form" @submit.prevent="submit">
    <div class="form-group">
      <div class="input-group" style="max-width: 375px">
        <input
          :value="search"
          @input="$emit('input', $event.target.value)"
          type="text"
          class="form-control"
          maxlength="14"
          name="gtin"
        />
        <span class="input-group-btn">
          <button
            :disabled="error || empty"
            class="btn btn-primary"
            type="submit"
          >
            {{ $t('search_button') }}
          </button>
        </span>
      </div>
      <span v-if="example" class="help-block">
        {{ $t('example_search') }}
        <a href="#" @click.prevent="useExample">{{ example }}</a>
      </span>
    </div>
  </form>
</template>

<script>
import { validateGtin } from '@/mixins/validateGtin'
export default {
  props: ['example', 'value'],
  mixins: [validateGtin],
  data() {
    return {
      error: false
    }
  },
  watch: {
    value() {
      this.validate()
    }
  },
  computed: {
    empty() {
      return this.search === ''
    },
    search() {
      return this.value
    }
  },
  created() {
    this.checkDigitOk()
  },
  methods: {
    setError(key, suggestion) {
      if (key == null) {
        this.error = false
        this.$emit('error', null)
      } else {
        this.error = true
        this.$emit('error', { key, suggestion })
      }
    },
    checkDigitOk() {
      if (this.error || this.empty) {
        return false
      }
      try {
        this.validateGtin(this.value)
      } catch (e) {
        this.setError(e.code, e.suggestion)
        return false
      }
      return true
    },
    submit() {
      this.validate()
      if (this.checkDigitOk()) {
        this.$emit('submit', this.value)
        return
      }
      this.$emit('input', this.value)
    },
    useExample() {
      this.$emit('input', this.example)
    },
    validate() {
      const numeric = /^\d*$/.test(this.value)
      if (!numeric) {
        this.setError('NON_NUMERIC')
      } else {
        this.setError(null)
      }
      this.$emit('input', this.value)
    }
  },
  i18n: {
    messages: {
      de: {
        search_button: 'Suchen',
        example_search: 'Beispielsuche:'
      },
      en: {
        search_button: 'Search',
        example_search: 'Example search:'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SearchForm.vue